module.exports = "/lucky-balls/img/red-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/red-ball.png
// module id = 103
// module chunks = 0